jQuery(document).ready(function ($) {

  //选产品颜色	
  let colors = {
		white: ['white','pinkish cloud','pearl bush','cloud'],
		beige: ['beige','soft amber','light clay','khaki','tapioca','sandrift','milk tea','cream','pale milk tea','early dawn','light khaki','cotton seed','light vanilla'],
		grey: ['grey','light cloud','moon mist','pale slate','light taupe','powder ash','star dust','cement','rock'],
		brown: ['brown','tan','copper','mushroom','light tan'],
		blue: ['blue','aqua','aqua haze','pale aqua','dark aqua'],
		green: ['green','teal','cyan','pale teal',' olive oil',' dark teal','light teal','emerald','spring rain','solid teal','pale mint'],
		yellow: ['yellow','golden','lemon ginger'],
    red: ['red','rose'],
		orange: ['orange','coral reef'],
		natural: ['natural','linen','satin linen'],
		pink: ['pink','pinkish']
	};

	function getUrlParam(name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
		var r = window.location.search.substr(1).match(reg);  //匹配目标参数
		if (r != null) return unescape(r[2]); return null; //返回参数值
	}

  function selectCOlor(main_color){
    main_colors = (main_color in colors)?colors[main_color]:[main_color];
    if(main_colors.length){
      $('.lakit-swatch-control span.swatch-anchor span').each(function(){
        color = $(this).html().toLowerCase();
        color = color.replaceAll("-"," ");
        colors = color.split(" ");
        var c = colors.filter(function(v){
           return main_colors.indexOf(v.toLowerCase()) > -1 
          })
        if(c.length){
          url=$(this).parent().parent().attr("data-thumb"); 
          if(url){
            $(this).parents(".product_item--inner").find(".p_img-first img").attr("srcset",url);
          } 
          url2=$(this).parent().parent().attr("data-thumb2"); 
          if(url2){
            $(this).parents(".product_item--inner").find(".p_img-second div").css("background-image","url('"+url2 +"')");
          }
          $(this).parent().parent().trigger('mouseenter');
        }
      });
    }
  } 

	function hoverColor(){
		var filter_main_color = getUrlParam('filter_main-color');
		var search_color = getUrlParam('s');
    if(filter_main_color){
      var main_color=filter_main_color.split(",");
      main_color = (main_color[0]).toLowerCase();
      selectCOlor(main_color);
    }else if(search_color){
      var main_color=search_color.split("+");
      for(let item of main_color) {
        selectCOlor(item.toLowerCase());
      }
    }
	}

  setTimeout(hoverColor, 1000);

  let custom_url = window.location.href;
  var single_mtsi_custom_curtain_width = $("#mtsi_custom_curtain_width").val();
  var single_mtsi_custom_curtain_length = $("#mtsi_custom_curtain_length").val();
  var single_mtsi_custom_curtain_unit_val = $("#mtsi_custom_curtain_width_unit").val();
  var minimum_value = 12;  

  if (single_mtsi_custom_curtain_unit_val == "cm") {
    minimum_value = 30;
  }
  if (single_mtsi_custom_curtain_width < minimum_value) {
    $('#cstm_add_to_cart_btn').prop('disabled', true);
    $('#mtsi_custom_curtain_width').focus();
  } else {
    $('#mtsi_custom_curtain_width').siblings("span").css('display', 'none');
  }
  if (single_mtsi_custom_curtain_length < minimum_value) {
    $('#cstm_add_to_cart_btn').prop('disabled', true);
    $('#mtsi_custom_curtain_length').focus();
  } else {
    $('#mtsi_custom_curtain_length').siblings("span").css('display', 'none');
  }

  $('#mtsi_custom_curtain_width').on('input', function () {
    let single_mtsi_custom_curtain_width1 = $("#mtsi_custom_curtain_width").val();
    let single_mtsi_custom_curtain_length1 = $("#mtsi_custom_curtain_length").val();
    let single_mtsi_custom_curtain_unit_val1 = $("#mtsi_custom_curtain_width_unit").val();

    let minimum_value = 12;
    if (single_mtsi_custom_curtain_unit_val1 == "cm") {
      minimum_value = 30;
    }

    if (single_mtsi_custom_curtain_width1 < minimum_value || single_mtsi_custom_curtain_length1 < minimum_value) {
      $('#cstm_add_to_cart_btn').prop('disabled', true);
    } else {
      $('#cstm_add_to_cart_btn').prop('disabled', false);
    }
    if (single_mtsi_custom_curtain_width1 >= 12) {
      $('#mtsi_custom_curtain_width').siblings("span").css('display', 'none');
    } else {
      $('#mtsi_custom_curtain_width').siblings("span").css('display', 'block');
    }
  });
  $('#mtsi_custom_curtain_length').on('input', function () {
    let single_mtsi_custom_curtain_width1 = $("#mtsi_custom_curtain_width").val();
    let single_mtsi_custom_curtain_length1 = $("#mtsi_custom_curtain_length").val();
    let single_mtsi_custom_curtain_unit_val1 = $("#mtsi_custom_curtain_width_unit").val();

    let minimum_value = 12;
    if (single_mtsi_custom_curtain_unit_val1 == "cm") {
      minimum_value = 30;
    }
    if (single_mtsi_custom_curtain_width1 < minimum_value || single_mtsi_custom_curtain_length1 < minimum_value) {
      $('#cstm_add_to_cart_btn').prop('disabled', true);
    } else {
      $('#cstm_add_to_cart_btn').prop('disabled', false);
    }
    if (single_mtsi_custom_curtain_length1 >= 12) {
      $('#mtsi_custom_curtain_length').siblings("span").css('display', 'none');
    } else {
      $('#mtsi_custom_curtain_length').siblings("span").css('display', 'block');
    }
  });
  $('#mtsi_custom_curtain_width').on('blur', function () {
    let single_mtsi_custom_curtain_width1 = $("#mtsi_custom_curtain_width").val();
    let single_mtsi_custom_curtain_length1 = $("#mtsi_custom_curtain_length").val();
    let single_mtsi_custom_curtain_unit_val1 = $("#mtsi_custom_curtain_width_unit").val();

    let minimum_value = 12;
    if (single_mtsi_custom_curtain_unit_val1 == "cm") {
      minimum_value = 30;
    }
    if (single_mtsi_custom_curtain_width1 < minimum_value || single_mtsi_custom_curtain_length1 < minimum_value) {
      $('#cstm_add_to_cart_btn').prop('disabled', true);
    } else {
      $('#cstm_add_to_cart_btn').prop('disabled', false);
      $('#mtsi_custom_curtain_width').siblings("span").css('display', 'none');
    }
    if (single_mtsi_custom_curtain_width1 >= minimum_value) {
      $('#mtsi_custom_curtain_width').siblings("span").css('display', 'none');
    } else {
      $('#mtsi_custom_curtain_width').siblings("span").css('display', 'block');
    }
  });
  $('#mtsi_custom_curtain_length').on('blur', function () {
    let single_mtsi_custom_curtain_width1 = $("#mtsi_custom_curtain_width").val();
    let single_mtsi_custom_curtain_length1 = $("#mtsi_custom_curtain_length").val();
    let single_mtsi_custom_curtain_unit_val1 = $("#mtsi_custom_curtain_width_unit").val();

    let minimum_value = 12;
    if (single_mtsi_custom_curtain_unit_val1 == "cm") {
      minimum_value = 30;
    }
    if (single_mtsi_custom_curtain_width1 < minimum_value || single_mtsi_custom_curtain_length1 < minimum_value) {
      $('#cstm_add_to_cart_btn').prop('disabled', true);
    } else {
      $('#cstm_add_to_cart_btn').prop('disabled', false);
      $('#mtsi_custom_curtain_length').siblings("span").css('display', 'none');
    }
    if (single_mtsi_custom_curtain_length1 >= minimum_value) {
      $('#mtsi_custom_curtain_length').siblings("span").css('display', 'none');
    } else {
      $('#mtsi_custom_curtain_length').siblings("span").css('display', 'block');
    }
  });

  $('#elementor-tab-title-2601').addClass('elementor-active');
  $('#elementor-tab-content-2601').addClass('elementor-active');
  $('#elementor-tab-content-2601').css('display', 'block');
  $('#elementor-tab-title-1481').addClass('elementor-active');
  $('#elementor-tab-content-1481').addClass('elementor-active');
  $('#elementor-tab-content-1481').css('display', 'block');
  $('#elementor-tab-title-2214').addClass('elementor-active');
  $('#elementor-tab-content-2214').css('display', 'block');
  $('#elementor-tab-content-2214').css('display', 'block');

  /*hide and show gifimage*/
  $(".gifimg").hide();
  // When the user clicks on the <i> element with the class fa-question-circle
  $(".gifimgclick").click(function () {
    // Display the .gifimg class
    $(".gifimg").toggle();
  });

  /*hide and show gifimage*/
  $(".gifclass").hide();
  // When the user clicks on the <i> element with the class fa-question-circle
  $(".gifClassClick").click(function () {
    // Display the .gifimg class
    $(".gifclass").toggle();
  });

  $('#mtsi_custom_curtain_width_unit').on('change', function () {
    let single_mtsi_custom_curtain_width1 = $("#mtsi_custom_curtain_width").val();
    let single_mtsi_custom_curtain_length1 = $("#mtsi_custom_curtain_length").val();
    var unit = $(this).children('option:selected').val();//这就是selected的值  
    if (unit == "cm") {
      if (single_mtsi_custom_curtain_width1 < 30 || single_mtsi_custom_curtain_length1 < 30) {
        $('#cstm_add_to_cart_btn').prop('disabled', true);
      } else {
        $('#cstm_add_to_cart_btn').prop('disabled', false);
      }
    } else {
      if (single_mtsi_custom_curtain_width1 < 12 || single_mtsi_custom_curtain_length1 < 12) {
        $('#cstm_add_to_cart_btn').prop('disabled', true);
      } else {
        $('#cstm_add_to_cart_btn').prop('disabled', false);
      }
    }
    var unitStr = "12 " + unit;
    if (unit == "cm") {
      unitStr = "30 " + unit;
    }
    console.log(unitStr);
    $(this).parents('.col-md-6').find('span').each(function () {
      var originalHtml = $(this).html();
      console.log(originalHtml);
      if (originalHtml) {
        var newHtml = originalHtml.replace('12 inches', unitStr);
        newHtml = newHtml.replace('30 inches', unitStr);
        newHtml = newHtml.replace('12 cm', unitStr);
        newHtml = newHtml.replace('30 cm', unitStr);
        $(this).html(newHtml);
        console.log(newHtml);
      }
    });
    $(this).parents('.col-md-6').find('select').each(function () {
      $(this).val(unit);
    });
  });
  $('#mtsi_custom_curtain_length_unit').on('change', function () {
    let single_mtsi_custom_curtain_width1 = $("#mtsi_custom_curtain_width").val();
    let single_mtsi_custom_curtain_length1 = $("#mtsi_custom_curtain_length").val();
    var unit = $(this).children('option:selected').val();//这就是selected的值  
    if (unit == "cm") {
      if (single_mtsi_custom_curtain_width1 < 30 || single_mtsi_custom_curtain_length1 < 30) {
        $('#cstm_add_to_cart_btn').prop('disabled', true);
      } else {
        $('#cstm_add_to_cart_btn').prop('disabled', false);
      }
    } else {
      if (single_mtsi_custom_curtain_width1 < 12 || single_mtsi_custom_curtain_length1 < 12) {
        $('#cstm_add_to_cart_btn').prop('disabled', true);
      } else {
        $('#cstm_add_to_cart_btn').prop('disabled', false);
      }
    }


    var unitStr = "12 " + unit;
    if (unit == "cm") {
      unitStr = "30 " + unit;
    }
    console.log(unitStr);
    $(this).parents('.col-md-6').find('span').each(function () {
      var originalHtml = $(this).html();
      console.log(originalHtml);
      if (originalHtml) {
        var newHtml = originalHtml.replace('12 inches', unitStr);
        newHtml = newHtml.replace('30 inches', unitStr);
        newHtml = newHtml.replace('12 cm', unitStr);
        newHtml = newHtml.replace('30 cm', unitStr);
        $(this).html(newHtml);
        console.log(newHtml);
      }
    });
    $(this).parents('.col-md-6').find('select').each(function () {
      $(this).val(unit);
    });
  });

  $("#mtsi_above").attr("disabled", true);
  $("#mtsi_puddle").attr("disabled", true);
  $('#mtsi_bottom').on('change', function () {
    bottom_val = $('input[name="mtsi_bottom"]:checked').val();
    if (bottom_val == 'Kiss Floor') {
      $("#mtsi_above").val('');
      $("#mtsi_puddle").val('');
      $("#mtsi_above").attr("disabled", true);
      $("#mtsi_puddle").attr("disabled", true);
    }else if (bottom_val == 'Above Floor') {
      $("#mtsi_above").attr("disabled", false);      
      $("#mtsi_puddle").val();
      if(!$("#mtsi_above").val()){
        $("#mtsi_above").val(1);
      }
      $("#mtsi_puddle").attr("disabled", true);
    }else if (bottom_val == 'Puddle') {
      $("#mtsi_puddle").attr("disabled", false);
      $("#mtsi_above").val('');
      if(!$("#mtsi_puddle").val()){
        $("#mtsi_puddle").val(2);
      }
      $("#mtsi_above").attr("disabled", true);
    }
  });

  // Function to append "inches" to the number field
  // 假设有一个input元素，其ID为myInput
  $('.mtsi_rod_unit').on('change', function () {
    var unit = $(this).children('option:selected').val();//这就是selected的值  
    $("#mtsi_custom_curtain_width_unit").val(unit)
    //console.log(unit);
    $('.mtsi_section').find('input').each(function () {
      var originalPlaceholder = $(this).attr('placeholder');
      if (originalPlaceholder) {
        var newPlaceholder = originalPlaceholder.replace('inches', unit);
        newPlaceholder = newPlaceholder.replace('cm', unit);
        $(this).attr('placeholder', newPlaceholder);
        //console.log(newPlaceholder);
      }
    });
    $('.mtsi_section').find('.apendspan').each(function () {
      var originalPlaceholder = $(this).text();
      if (originalPlaceholder) {
        var newPlaceholder = originalPlaceholder.replace('inches', unit);
        newPlaceholder = newPlaceholder.replace('cm', unit);
        $(this).text(newPlaceholder);
        //console.log(newPlaceholder);
      }
    });


  });

  // Function to append "inches" to the number field

  function appendInches() {
    var mtsi_custom_curtain_width = $("#mtsi_custom_curtain_width");
    var mtsi_custom_curtain_length = $("#mtsi_custom_curtain_length");

    if (mtsi_custom_curtain_width.length > 0) {
      mtsi_custom_curtain_width.after("<span class='apendspan'> inches</span>");
    }
    if (mtsi_custom_curtain_length.length > 0) { // Check if the field exists
      mtsi_custom_curtain_length.after("<span class='apendspan'> inches</span>");
    }

  }

  // Call the function initially
  // appendInches();

  /*Add content after bar discription*/
  var methodParagraph = $('div.steps-step p:contains("Method")');
  var methodNew = $('<p id="fetch_sel_method_insta_txt1"> </p>');
  var headerParagraph = $('div.steps-step p:contains("Header")');
  var headerNew = $('<p id="fetch_sel_header_type_txt1"> </p>');
  var rodInstalledParagraph = $('div.steps-step p:contains("Rod Installed")');
  var rodNew = $('<p id="fetch_sel_rod_insta_txt1"> </p>');
  var coverageWidthParagraph = $('div.steps-step p:contains("Coverage Width")');
  var coverageNew = $('<p id="fetch_sel_coverage_width_txt1"> </p>');
  var coverageLengthParagraph = $('div.steps-step p:contains("Coverage Length")');
  var coverageLengthNew = $('<p id="fetch_sel_coverage_length_txt1"> </p>');
  var panelParagraph = $('div.steps-step p:contains("Panels")');
  var panelNew = $('<p id="fetch_sel_panel_txt1"> </p>');
  var fullnessParagraph = $('div.steps-step p:contains("Fullness")');
  var fullnessNew = $('<p id="fetch_sel_fullness_txt1"> </p>');
  var BottomParagraph = $('div.steps-step p:contains("Bottom")');
  var BottomNew = $('<p id="fetch_sel_bottom_txt1"> </p>');
  // Insert the new <p> tag after the existing one
  methodParagraph.after(methodNew);
  headerParagraph.after(headerNew);
  rodInstalledParagraph.after(rodNew);
  coverageWidthParagraph.after(coverageNew);
  coverageLengthParagraph.after(coverageLengthNew);
  panelParagraph.after(panelNew);
  fullnessParagraph.after(fullnessNew);
  BottomParagraph.after(BottomNew);

}); //closed main function

var timeoutExecuted = false;
setTimeout(function () {
  if (!timeoutExecuted) {
    timeoutExecuted = true;
    jQuery(document).ready(function ($) {
      if ($('.uacf7-form-3261 span.mtsi_method_radio #mtsi_method span.wpcf7-list-item-label').length) {
        $('span.mtsi_header_radio #mtsi_header_type').parents("form").addClass("form_active");
        $('span.mtsi_header_radio #mtsi_header_type').find(".wpcf7-list-item").css("display", "none");
        $('span.mtsi_header_radio #mtsi_header_type span.wpcf7-list-item-label').each(function (indx, imgVal) {
          if (indx < 4) {
            $(this).parents(".wpcf7-list-item").css("display", "inline-block");
          }
        });
        $('span.mtsi_method_radio #mtsi_method span.wpcf7-list-item-label').click(function () {

          // $('div.steps-step').removeClass("step-complete");
          $('div.steps-step').find('a').removeClass("completed");
          $('span.wpcf7-list-item-label').removeClass("selected_item");
          $(this).addClass("selected_item");
          $("#fetch_sel_method_insta_txt1").html($(this).parent().find('input[type="radio"]').val());

          $(this).parent().find('input[type="radio"]').click();

          if ($("#2904step-1 button.uacf7-next").length) {
            $('.mtsi-form-area #2904step-1 button.uacf7-next').click();
          } else {
            $('.mtsi-form-area #999step-1 button.uacf7-next').click();
          }
          let mtsi_method_radio_value = $(this).siblings("input").val();
          $('span.mtsi_header_radio #mtsi_header_type').find(".wpcf7-list-item").css("display", "none");
          $('span.mtsi_header_radio #mtsi_header_type span.wpcf7-list-item-label').each(function (indx, imgVal) {
            if (mtsi_method_radio_value == "Rod" && indx < 4) {
              $(this).parents(".wpcf7-list-item").css("display", "inline-block");
            }
            if (mtsi_method_radio_value == "Track" && indx > 3) {
              $(this).parents(".wpcf7-list-item").css("display", "inline-block");
            }
          });

        });
      }

      if ($(".uacf7-form-3261 #mtsi_header_type .wpcf7-list-item").length) {
        $("#mtsi_header_type .wpcf7-list-item:nth-child(1) label").after('<div class="mtsi-heading"><h6 class="mtsi-title"> Grommet </h6> </div>');
        $("#mtsi_header_type .wpcf7-list-item:nth-child(2) label").after('<div class="mtsi-heading"><h6 class="mtsi-title"> Rod Pocket </h6></div>');
        $("#mtsi_header_type .wpcf7-list-item:nth-child(3) label").after('<div class="mtsi-heading"><h6 class="mtsi-title"> Back Tap </h6> </div>');
        $("#mtsi_header_type .wpcf7-list-item:nth-child(4) label").after('<div class="mtsi-heading"><h6 class="mtsi-title"> Pinch Pleat </h6> </div>');
        $("#mtsi_header_type .wpcf7-list-item:nth-child(5) label").after('<div class="mtsi-heading"><h6 class="mtsi-title"> Pinch Pleat </h6></div>');
        $("#mtsi_header_type .wpcf7-list-item:nth-child(6) label").after('<div class="mtsi-heading"><h6 class="mtsi-title"> S-Fold </h6></div>');
      }

      if ($('.uacf7-form-22972 span.mtsi_method_radio #mtsi_method span.wpcf7-list-item-label').length) {
        $('span.mtsi_header_radio #mtsi_header_type').parents("form").addClass("form_active");
        $('span.mtsi_header_radio #mtsi_header_type').find(".wpcf7-list-item").css("display", "none");
        $('span.mtsi_header_radio #mtsi_header_type span.wpcf7-list-item-label').each(function (indx, imgVal) {
          if (indx < 6) {
            $(this).parents(".wpcf7-list-item").css("display", "inline-block");
          }
        });
      }      

    });
  }
});

jQuery(document).ready(function ($) {
  function isBlockCheckoutPage() {
    // 方法 1: 区块结算页 DOM
    if (document.querySelector('.wp-block-woocommerce-checkout')) return true;

    // 方法 2: body class（WooCommerce 会在结算页加上这些 class）
    if (document.body.classList.contains('woocommerce-checkout') ||
        document.body.classList.contains('is-checkout')) return true;

    return false;
}
  $(window).scroll(function () {
    if (!isBlockCheckoutPage()) {//判断当前页面不是结算页才使用粘性头部
    if ($(this).scrollTop() > 0) {
      $(".home-header2").addClass("elementor-sticky--effects");
    } else {
      $(".home-header2").removeClass("elementor-sticky--effects");
    }
    }
  });
  //控制变体产品，无库存更改样式
  $('form.variations_form').on('change', function () {
    var product_variations = $(".variations_form").data('product_variations');
    var formData = $(this).serializeArray();
    //console.log(product_variations); // 输出：name, size
    var variationId = formData.find(function (item) {
      return item.name === 'variation_id';
    }).value;
    $(this).removeClass("class-disabled");
    for (var i = 0; i < product_variations.length; i++) {
      if (product_variations[i].variation_id == variationId && product_variations[i].availability_html.indexOf("Out of stock") > 0) {
        $(this).addClass("class-disabled");
      }
    }

  });

  $(".figure__object_fit img").click(function () {
    $(this).siblings().toggleClass("fsp-swatch-img-thumb");
    $(this).toggleClass("fsp-swatch-img-thumb");
  });

});

